export default () => {
  window.jQuery('body').on('click', '#sidebarToggle', function (e) {
    e.preventDefault();
    window.jQuery('body').toggleClass('sb-sidenav-toggled');
  });
};
